(function () {
  'use strict';

  angular.module('app').component('taxesPage', taxListCtrl());

  function taxListCtrl() {
    return {
      bindings: {},
      controller: TaxListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/taxes/taxes-pages.component.html',
    };
  }

  TaxListCtrl.$inject = [
    'UtilService',
    'AbilityService',
    'SessionService',
    'TaxService',

    // Angular downgraded service
    'companyService',
  ];

  function TaxListCtrl(UtilService, AbilityService, SessionService, TaxService, companyService) {
    const vm = this;

    // public properties
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_tax_accountadmin'),
    };

    // private properties
    let companyId = SessionService.getSelectedAccountCompany().id;

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.createTax = function () {
      TaxService.openTaxDetailModal({}, 'create', vm.taxes, getTaxes);
    };

    // Initializers
    getTaxes('');
    getCompany();

    function getTaxes(selectedItem) {
      vm.taxes = null;

      vm.loadingTaxes = true;
      TaxService.getTaxes().then(function (data) {
        vm.taxes = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingTaxes = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getCompany() {
      companyService
        .getCompany(companyId, { skip_check_role: true, lang: userLanguageCode })
        .subscribe((response) => {
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types || [];
          }
        });
    }
  }
})();
